export const API_TIMEOUTS = {
  DEFAULT: 50000,
  CREATE_BAITCHECKER: 50000,
};
